
import { Language } from './languageData';
import { translations } from './translations';

// Helper function to translate text with robust fallback system
export const translate = (key: string, language: Language): string => {
  if (!translations[key]) {
    console.warn(`Translation key not found: ${key}`);
    // Return a user-friendly fallback instead of the raw key
    return key.replace(/([A-Z])/g, ' $1')
              .replace(/^./, str => str.toUpperCase())
              .trim();
  }
  
  // Try current language first
  if (translations[key][language]) {
    return translations[key][language];
  }
  
  // Fallback to English
  if (translations[key]['en']) {
    return translations[key]['en'];
  }
  
  // Last resort: return formatted key
  return key.replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase())
            .trim();
};

// Strip the language prefix from a path
export const stripLanguageFromPath = (path: string): string => {
  // Match any of the 40 supported language codes
  const langMatch = path.match(/^\/(en|es|fr|de|it|pt|da|no|fi|sv|is|cs|sk|sl|pl|et|lv|lt|el|nl|ko|ja|zh|ar|hi|ru|tr|id|ro|bg|hr|hu|uk|he|th|vi|ms|tl|fa|bn|ur|sw)(\/.*)$/);
  return langMatch ? langMatch[2] : path;
};

// Get the localized path for a specific language
export const getLocalizedPathForLanguage = (path: string, lang: Language): string => {
  // Strip any existing language prefix
  const cleanPath = stripLanguageFromPath(path);
  
  // For the root path, handle it specially
  if (cleanPath === '/' || cleanPath === '') {
    return lang === 'en' ? '/' : `/${lang}/`;
  }
  
  return lang === 'en' ? cleanPath : `/${lang}${cleanPath}`;
};
